
import "./HeroAnimated.css";


export default function HeroAnimated() {
 

  return (
    <section className="hero-animated">
      <div className="hero-content">
        <h1>
          The Extra Set of Eyes,
          <br />
          You Wish You Had.
        </h1>

        <p>
          Most platforms track surface-level metrics—but these are just symptoms.
          They don’t reveal root causes or explain where delays begin.
        </p>

        <p>
          That’s where Argus steps in. This smart AI connects to your existing CCTV,
          monitoring operations in real time and turning issues into insights.
        </p>

        <p>
          So while others track the surface, Argus helps you get to the core.
        </p>
      </div>

     
    </section>
  );
}
